// @workflow assistant.ui-tools
/**
 * The words the UI tools speak (contract "UI tools: who decides what", rule 3): every tool name,
 * every error code, and the one shape a result takes. Shared by the registry (uiTools.js) and the
 * tool groups it is built from, so no name or code is spelled twice.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

export const UI_TOOL = Object.freeze({
  NAVIGATE: 'ui.navigate',
  VIEWER_FOCUS_TAGS: 'ui.viewer.focus_tags',
  VIEWER_COLOR_TAGS: 'ui.viewer.color_tags',
  VIEWER_RESET: 'ui.viewer.reset',
  VIEWER_SET_GHOSTING: 'ui.viewer.set_ghosting',
  VIEWER_SELECTION: 'ui.viewer.selection',
  VIEWER_LINK_360: 'ui.viewer.link_360',
  TAGS_OPEN_PANEL: 'ui.tags.open_panel',
  TAGS_OPEN_360: 'ui.tags.open_360',
  TAGS_SHOW_IN_2D: 'ui.tags.show_in_2d',
  TASKS_SHOW_IN_3D: 'ui.tasks.show_in_3d',
  TASKS_OPEN_ON_BOARD: 'ui.tasks.open_on_board',
  TASKS_SHOW_ON_BOARD: 'ui.tasks.show_on_board',
  REGISTERS_OPEN_IMPORT: 'ui.registers.open_import',
  DOCUMENTS_OPEN: 'ui.documents.open',
});

/** Error codes the UI answers with; the server turns them into business words. */
export const UI_TOOL_ERROR = Object.freeze({
  UNSUPPORTED: 'unsupported',
  NOT_AVAILABLE: 'not_available',
  FAILED: 'failed',
});

/**
 * `{ ok: true }`, or `{ ok: true, data }` for a query and for an action that reports what it did
 * (focus_tags / color_tags: `{ shown, skipped }`).
 */
export const ok = (data) => (data === undefined ? { ok: true } : { ok: true, data });

export const unsupported = () => ({ ok: false, error: UI_TOOL_ERROR.UNSUPPORTED });

/** `detail` is plain words the model can act on, e.g. "This facility has no 3D model." */
export const notAvailable = (detail) => ({ ok: false, error: UI_TOOL_ERROR.NOT_AVAILABLE, detail });

/** The runner's answer when the user lacks the tool's capability (`label`: actions/permissions.js). */
export const noAccess = (label) => notAvailable(`You don't have access to ${label}.`);

export const failed = (detail) => (detail ? { ok: false, error: UI_TOOL_ERROR.FAILED, detail } : { ok: false, error: UI_TOOL_ERROR.FAILED });
